var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sair"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-12 text-center middle"},[_c('h1',{staticClass:"text-uppercase"},[_vm._v("Deslogando do sistema")])])])])])
}]

export { render, staticRenderFns }